"use strict";
/** @internalapi */
exports.resolvePolicies = {
    when: {
        LAZY: "LAZY",
        EAGER: "EAGER"
    },
    async: {
        WAIT: "WAIT",
        NOWAIT: "NOWAIT",
        RXWAIT: "RXWAIT"
    }
};
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ui-router-core/lib/resolve/interface.js
// module id = 326
// module chunks = 1